<template lang="html">
  <action-bar id="neighbourhood-list-actions">
    <template slot="left">
      <single-select
      class="type-select d-none d-md-block"
      :label="typeLabel"
      @change="applyType"
      :options="[...mutableFilters.typeList.map(type => type.label)]"
      :selectedIndex="typeListIndex" />
    </template>
    <template slot="right">
      <single-select
      class="sort-select d-none d-md-block"
      :label="sortLabel"
      @change="applySort"
      :options="sortOptions"
      :selectedIndex="sortIndex" />
      <button class="btn btn-link-action d-block d-md-none"
      @click="showMobileSortDialog">
        {{ sortLabel }} <i class="fas fa-angle-down"></i>
      </button>
    </template>
  </action-bar>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { create } from 'vue-modal-dialogs';
import ActionBar from '@/components/ActionBar';
import CheckListComponent from '@/components/Input/Checklist';
import SingleSelectComponent from '@/components/Input/SingleSelect';
import SingleSelectDialog from '@/components/Dialogs/SingleSelectDialog';

const singleSelectDialog = create(SingleSelectDialog, 'options', 'selectedIndex');

export default {
  name: 'neighbourhood-list-actions',
  computed: {
    ...mapState({
      filters: state => state.neighbourhood.filters
    }),
    typeLabel() {
      let activeFilter = 'Type';
      // if (this.typeListIndex !== 0) {
        activeFilter = this.mutableFilters.typeList[this.typeListIndex].label;
      // }
      return activeFilter;
    },
    sortLabel() {
      switch (this.sortIndex) {
        case -1: return 'Sort By';
        case 0: return 'Number';
        case 1: return 'Walk Time';
        case 2: return 'Transit Time';
        case 3: return 'Drive Time';
        default: return 'Sort By';
      }
    }
  },
  data() {
    return {
      sortOptions: [
        'Number',
        'Walk time',
        'Transit time',
        'Drive time'
      ],
      mutableFilters: {},
      sortIndex: -1,
      typeListIndex: 0
    };
  },
  methods: {
    ...mapMutations({
      setFilters: 'neighbourhood/setFilters',
      sortByOrderId: 'neighbourhood/sortByOrderId',
      sortByTravelTime: 'neighbourhood/sortByTravelTime',
      setSelectedPoiId: 'neighbourhood/setSelectedPoiId'
    }),
    applyType(index) {
      this.typeListIndex = index;
      this.mutableFilters.typeList.forEach((filter) => {
        filter.active = false;
      });
      // if (this.typeListIndex > 0) {
        this.mutableFilters.typeList[this.typeListIndex].active = true;
      // }
      this.setFilters(this.mutableFilters);
      this.setSelectedPoiId('');
    },
    applySort(index) {
      this.sortIndex = index;
      this.sortPoiList();
    },
    async showMobileSortDialog() {
      this.sortIndex =
        await singleSelectDialog(
          this.sortOptions,
          this.sortIndex
        );
      this.sortPoiList();
    },
    revertMutableFilters() {
      this.mutableFilters = JSON.parse(JSON.stringify(this.filters));
    },
    sortPoiList() {
      switch (this.sortIndex) {
        case 1:
          this.sortByTravelTime('walk');
          break;
        case 2:
          this.sortByTravelTime('transit');
          break;
        case 3:
          this.sortByTravelTime('drive');
          break;
        default:
          console.log('defaulting');
          this.sortByOrderId();
          break;
      }
    }
  },
  created() {
    this.revertMutableFilters();
    this.mutableFilters.typeList[0].active = true;
    this.setFilters(this.mutableFilters);

  },
  watch: {
    filters() {
      this.revertMutableFilters();
    }
  },
  components: {
    'check-list': CheckListComponent,
    'action-bar': ActionBar,
    'single-select': SingleSelectComponent,
  }
};
</script>

<style lang="scss">
#neighbourhood-list-actions {
  background: white;

  -webkit-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
}

.type-select {
  .options {
    min-width: 200px!important;
  }
}

.sort-select {
  .options {
    right: 0!important;
    min-width: 150px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodMap/NeighbourhoodListActions.vue